import * as React from "react";
export var PageDataContext = /*#__PURE__*/React.createContext({});
export function usePageData() {
  return React.useContext(PageDataContext);
}